import React, { useState } from 'react';
import './App.css'; // Assuming CSS is in this file
import { BrowserRouter, Routes, Route, Outlet, useNavigate } from 'react-router-dom'

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

// Main App Component
const App = () => {
  // State for active navigation item
  const [activeNav, setActiveNav] = useState('feed');
  const userID = JSON.parse(localStorage.getItem("user")).uuid;
  // Navigation items data
  const discoverItems = [
    { id: '', label: 'Live Feed' },
    { id: 'explore', label: 'Explore' }
  ];
  const socialItems = [
    { id: 'friends', label: 'Friends' },
    { id: `profile/${userID}`, label: 'My Profile' },
    { id: 'notifications', label: 'Notifications' }
  ]
  const accountItems = [
    {id: 'settings', label: 'Settings' }
  ]

  return (
    <div className="app-shell">
      {/* Sidebar Component */}
      <Sidebar
        activeNav={activeNav}
        setActiveNav={setActiveNav}
        discoverItems={discoverItems}
        socialItems={socialItems}
        accountItems={accountItems}
      />

      {/* Main Content Area */}
      <div className="main">
        <Outlet/>
      </div>
    </div>
  );
};

// Sidebar Component
const Sidebar = ({ activeNav, setActiveNav, setActivePage, discoverItems, socialItems, accountItems }) => {
  const navigate = useNavigate();
  const handleLogout = async () => {
    const res = await fetch(`${BACKEND_ORIGIN}/logout`, {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "credentials": "include"
    });
    if (res.ok) {
      return true;
    }
    else {
      return false;
    }
  }
  const handleLogoutClick = async() => {
    const loggedout = await handleLogout();
    if (loggedout) {
      localStorage.removeItem("user");
      navigate("/");
    }
    else {
      alert("Error logging out!");
    }
  }
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className="sidebar">
      {/* Logo Section */}
      <div className="logo">
        <div className="logo-text">
          POST<span>GAME</span>
        </div>
        <div className="logo-sub">SPORTS SOCIAL</div>
      </div>

      {/* Navigation Section */}
      <div className="nav">
        <div className="nav-label">Discover</div>
        {discoverItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
            onClick={() => {
              setActiveNav(item.id);
              navigate(`/app/${item.id}`)
            }}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
            {item.badge && <span className="badge">{item.badge}</span>}
          </button>
        ))}
        <div className="nav-label">Social</div>
        {socialItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
            onClick={() => {
              setActiveNav(item.id);
              navigate(`/app/${item.id}`)
            }}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
            {item.badge && <span className="badge">{item.badge}</span>}
          </button>
        ))}
        <div className="nav-label">Account</div>
        {accountItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
            onClick={() => {
              setActiveNav(item.id);
              navigate(`/app/${item.id}`);
            }}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
            {item.badge && <span className="badge">{item.badge}</span>}
          </button>
        ))}
        <button className={`nav-item`} onClick={handleLogoutClick}>
          <span>Logout</span>
        </button>
      </div>

      {/* Bottom User Section */}
      <div className="sidebar-bottom">
        <div className="user-pill" onClick={() => navigate(`/app/profile/${user.uuid}`)}>
          <div className="avatar verified">USER</div>
          <div className="user-info-small">
            <div className="name">{user.firstName + " " + user.lastName}</div>
            <div className="handle">@{user.userName}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
